export class AgeComparison {
  constructor(ages, min_age, max_age) {
    this.ages = ages
    this.min_age = min_age
    this.max_age = max_age
  }

  maxAge() {
    return this.ages.find(function(age) {
      return age.accepted && age.max >= this.max_age
    }, this) != undefined
  }

  minAge() {
    return this.ages.find(function(age) {
      return age.accepted && age.min <= this.min_age
    }, this) != undefined
  }

  resolve() {
    return this.minAge() && this.maxAge()
  }
}
